















































































































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import Referensi from "@/services/Referensi";
import LaporanRegisterRalanHarian, {
  RegisterRalanHarianRow,
  RegisterRalanHarianSummary
} from "@/services/LaporanRegisterRalanHarian";

interface UnitOption {
  id: string;
  nama: string;
}

@Component({})
export default class LaporanRegisterRalanHarianPage extends Vue {
  today = moment().format("YYYY-MM-DD");
  tglStart = moment().format("YYYY-MM-DD");
  tglEnd = moment().format("YYYY-MM-DD");
  showStart = false;
  showEnd = false;

  selectedUnits: string[] = [];
  unitOptions: UnitOption[] = [];
  loadingUnits = false;

  jenisKunjungan: "semua" | "baru" | "lama" = "semua";
  jenisKunjunganOptions = [
    { text: "Semua", value: "semua" },
    { text: "Baru", value: "baru" },
    { text: "Lama / Kontrol", value: "lama" }
  ];

  loading = false;
  loadingPdf = false;
  loadingExcel = false;
  rows: RegisterRalanHarianRow[] = [];
  summary: RegisterRalanHarianSummary | null = null;

  headers = [
    { text: "Tgl", value: "tgl", width: 90 },
    { text: "No. Reg", value: "no_register", width: 90 },
    { text: "Jam Daftar", value: "jam", width: 80 },
    { text: "Jam Layan", value: "jam_layanan", width: 80 },
    { text: "Tunggu", value: "waktu_tunggu_menit", width: 100 },
    { text: "NRM", value: "nrm", width: 90 },
    { text: "NIK", value: "nik", width: 140 },
    { text: "Nama", value: "nama", width: 180 },
    { text: "JK", value: "jk", width: 50 },
    { text: "Umur", value: "umur", width: 80 },
    { text: "Alamat", value: "alamat", width: 260 },
    { text: "Provinsi", value: "provinsi", width: 140 },
    { text: "Kab/Kota", value: "kabupaten", width: 160 },
    { text: "Cara Bayar", value: "cara_bayar", width: 130 },
    { text: "No SEP", value: "no_sep", width: 130 },
    { text: "Poli", value: "poli", width: 150 },
    { text: "Jenis", value: "jenis_kunjungan", width: 70 },
    { text: "Asal Rujukan", value: "asal_rujukan", width: 140 },
    { text: "DPJP", value: "dpjp", width: 180 },
    { text: "Dx ICD-10", value: "dx_text", width: 130 },
    { text: "Kasus Dx", value: "kasus_text", width: 90 },
    { text: "Tindakan", value: "tindakan_text", width: 220 },
    { text: "Status", value: "status", width: 90, align: "center" }
  ];

  get canSearch(): boolean {
    return !!this.tglStart && !!this.tglEnd && this.tglStart <= this.tglEnd;
  }

  get periodWarning(): string | null {
    if (!this.tglStart || !this.tglEnd) return null;
    const days = moment(this.tglEnd).diff(moment(this.tglStart), "days");
    if (days > 31) {
      return `Periode ${days + 1} hari melebihi 31 hari — gunakan periode lebih pendek atau export Excel.`;
    }
    return null;
  }

  mounted() {
    this.loadUnits();
  }

  async loadUnits() {
    this.loadingUnits = true;
    try {
      const data = await Referensi.getUnitPelayanan();
      const all: UnitOption[] = (data ?? []).map((u: any) => ({
        id: String(u.id),
        nama: u.nama
      }));
      // Filter unit ralan: kode '02'..'29' (selaras backend)
      this.unitOptions = all
        .filter(u => u.id > "01" && u.id < "30")
        .sort((a, b) => a.nama.localeCompare(b.nama));
    } catch {
      this.unitOptions = [];
    } finally {
      this.loadingUnits = false;
    }
  }

  buildFilter() {
    return {
      tgl_start: this.tglStart,
      tgl_end: this.tglEnd,
      unit: this.selectedUnits.length ? this.selectedUnits : undefined,
      jenis_kunjungan: this.jenisKunjungan
    };
  }

  async loadPreview() {
    if (!this.canSearch) return;
    this.loading = true;
    try {
      const res = await LaporanRegisterRalanHarian.preview(this.buildFilter());
      this.rows = res.rows;
      this.summary = res.summary;
    } finally {
      this.loading = false;
    }
  }

  async cetakPdf() {
    if (!this.canSearch || this.loadingPdf) return;
    this.loadingPdf = true;
    try {
      await LaporanRegisterRalanHarian.openPdf(this.buildFilter());
    } catch (e) {
      // sudah dilaporkan ErrorAlert
    } finally {
      this.loadingPdf = false;
    }
  }

  async downloadExcel() {
    if (!this.canSearch || this.loadingExcel) return;
    this.loadingExcel = true;
    try {
      await LaporanRegisterRalanHarian.downloadExcel(this.buildFilter());
    } catch (e) {
      // sudah dilaporkan ErrorAlert
    } finally {
      this.loadingExcel = false;
    }
  }

  dxFullText(item: RegisterRalanHarianRow): string {
    return item.diagnosis
      .map(d => `${d.kode} — ${d.deskripsi}`)
      .join("\n");
  }
  procFullText(item: RegisterRalanHarianRow): string {
    return item.prosedur
      .map(p => `${p.kode} — ${p.deskripsi}`)
      .join("\n");
  }
  dxKasusFullText(item: RegisterRalanHarianRow): string {
    if (!item.diagnosis || !item.diagnosis.length) {
      return "Belum ada diagnosis";
    }
    return item.diagnosis
      .map(d => `${d.kode} — ${d.kasus_label}`)
      .join("\n");
  }
  waktuTungguClass(item: RegisterRalanHarianRow): string {
    if (item.waktu_tunggu_menit === null) return "grey--text";
    return item.waktu_tunggu_menit > 60 ? "red--text" : "";
  }
}
